import React from 'react';
import colorVars from '@farmers-fridge/ui-library/dist/colors.module.css';
import Tag from './Tag';
import WarningIcon from '../icons/WarningIcon';

/**
 * @param {object} props
 * @param {string=} props.className
 */
function NotAvailableTag({ className }) {
  return (
    <Tag
      className={className}
      fillColor={colorVars.color_silver}
      height={26}
      width={98}
      title="Not Available"
    >
      <span>Not Available</span>
    </Tag>
  );
}

/**
 * @param {object} props
 * @param {string=} props.className
 */
function LowInventoryTag({ className }) {
  return (
    <Tag
      className={className}
      fillColor="#FFEDE5"
      height={26}
      width={132}
      title="Low Inventory"
    >
      <WarningIcon style={{ fill: colorVars.color_monza }} />
      <span>LOW IN STOCK</span>
    </Tag>
  );
}

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {FF.AWSProduct} props.product
 */
export default function InventoryTags({ className, product }) {
  if (typeof product.count === 'number') {
    if (product.count === 0) {
      return <NotAvailableTag className={className} />;
    }
    if (product.count <= 2) {
      return <LowInventoryTag className={className} />;
    }
  }

  return null;
}
